const reflinks = {
  reflinks: 'Адміністраторські рефлінки',
  showing: 'показується',
  reflinksOf: 'рефлінки',
  noReflinksFound: 'Рефлінків не знайдено',
  addNew: 'Додати нове',
  tableDropdown: {
    quickActions: 'Швидкі дії',
    refresh: 'Оновити',
    exportReflinks: 'Експортувати',
  },
  actionsDropdown: {
    update: 'Оновити',
    delete: 'Видалити',
  },
  modal: {
    addNewReflink: 'Додати нове рефлінк',
    email: 'Електронна пошта',
    name: "Ім'я",
    code: 'Код',
    category: 'Категорія',
    bonus: 'Бонус',
    editReflink: 'Редагувати рефлінк',
  },
  messages: {
    success: 'Нове рефлінк створено.',
    updateSuccess: 'Посилання збережено.',
    deleteSuccess: 'Посилання видалено.',
  }
};

export default reflinks;
